<template>
  <v-app>
    <v-main class="plashka">
      <v-container>
        <v-row>
          <div class="col-lg-8 col-xl-8  col-md-8 col-sm-12 col-xs-12 pa-0 text-center">
               <img src="./assets/images/1.png" width="100%" alt="">
              <Form></Form>
          </div>
          <div class="col-lg-4 col-xl-4 col-md-4 col-sm-12 col-xs-12 pa-0">
            <img src="./assets/images/2-1.png" width="100%" alt="">
          </div>
        </v-row>
        <v-row>
          <div class="col pa-0">

              <div class="line w-margin-top"></div>
              <div class="secondary--text w-title-text text-center">Подарунки</div>

          </div>
        </v-row>
        <v-row>
            <div class="col">
              <img src="./assets/images/3.png" width="100%" alt="">
            </div>
            <div class="col">
              <img src="./assets/images/4.png" width="100%" alt="">
            </div>
        </v-row>
        <v-row>
          <div class="col">
            <table class="customTable pl-8 pr-8">
              <thead>
              <tr>
                <th>Розіграш</th>
                <th>Дата проведення <br> розіграшу</th>
                <th>Розіграш серед кодів, <br> зареєстрованих протягом відповідного періоду</th>
                <th>Подарунки</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Щотижневий</td>
                <td>22 жовтня 2021 року</td>
                <td>З 14 жовтня по 20 жовтня 2021 року</td>
                <td>20 сертифікатів номіналом 500 грн <br>
                  на покупки у магазинах «Наш Край»</td>
              </tr>
              <tr>
                <td>Щотижневий</td>
                <td>29 жовтня 2021 року</td>
                <td>З 21 жовтня по 27 жовтня 2021 року</td>
                <td>20 сертифікатів номіналом 500 грн <br>
                  на покупки у магазинах «Наш Край»</td>
              </tr>
              <tr>
                <td>Щотижневий</td>
                <td>5 листопада 2021 року</td>
                <td>З 28 жовтня по 03 листопада 2021 року</td>
                <td>20 сертифікатів номіналом 500 грн <br>
                  на покупки у магазинах «Наш Край»</td>
              </tr>
              <tr>
                <td>Щотижневий</td>
                <td>12 листопада 2021 року</td>
                <td>З 04 листопада по 10 листопада 2021 року</td>
                <td>20 сертифікатів номіналом 500 грн <br>
                  на покупки у магазинах «Наш Край»</td>
              </tr>
              <tr>
                <td>Фінальний</td>
                <td>17 листопада 2021 року</td>
                <td>З 14 жовтня по 14 листопада 2021 року</td>
                <td>10 сертифікатів номіналом 10 000 грн <br>
                  на покупки у магазинах Comfy</td>
              </tr>

              </tbody>
            </table>
          </div>
        </v-row>
        <v-row>
          <div class="col text-center">
            <v-btn
                color="primary"
                class="w-button w-button-dialog"
                dark
                href="/file/переможці комфі 9999.pdf"
            >
              Переможці
            </v-btn>
            <div class="line w-margin-top"></div>
          </div>
        </v-row>
        <v-row class="mb-8">
          <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-xs-12 text-right">
            <div class="display-1 mb-6 secondary--text">Продукція, яка бере участь в акції</div>
            <v-btn
                color="secondary"
                class="w-button w-button-dialog w-diznatysa-bilshe"
                href="/file/Товари партнерів акції (2).pdf"
            >
              Дізнатися більше
            </v-btn>
          </div>
          <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-xs-12 w-right-bloc" style="position: relative;">
            <img class="w-absolute-image" src="./assets/images/5.png" width="70%" alt="">
          </div>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row>
          <div class="col pa-0 newcolor" style="z-index: 3;">
            <v-container>
              <v-row>
                <div class="col text-center" style="position: relative;" >
                  <img src="./assets/images/6.png" width="100%" alt="">
                </div>
              </v-row>
            </v-container>
          </div>
        </v-row>
      </v-container>
      <v-container>
        <v-row>
          <div class="col">
            <div class="text-center">
              <span class="w-text-fotter secondary--text">
                Обов'язково збережіть чек з кодом, який було зареєстровано на промо-сайті
для участі в акції. Організатор акції залишає за собою право здійснити перевірку
оригінальності чеку шляхом отримання копії чеку від Переможців розіграшів.
У випадку не підтвердження оригінальності чеку,
такий Переможець втрачає право на отримання Заохочення.
              </span>
            </div>
          </div>
        </v-row>
        <v-row>
          <div class="col text-center col-md-4">
            <v-btn
                color="secondary"
                class="w-button w-button-dialog"
                href="/file/Офіційні_правила_20_років_Наш_Край (2).pdf"
            >
              Правила акції
            </v-btn>
          </div>
          <div class="col col-md-4 text-center w-text-fotter">
            <div>
              <span class="secondary--text">
                Номер гарячої лінії:
              </span>
            </div>
            <div>
                <span class="w-tel secondary--text">
                  0 800 50 14 18
                </span>
            </div>
          </div>
          <div class="col col-md-4 text-center">
            <div class="w-text-fotter secondary--text">
              Підтримка:
            </div>
            <div>
              <a class="secondary--text w-tel" href="mailto:info@nashkraj.com.ua">info@nashkraj.com.ua</a>
            </div>
          </div>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Form from './components/Form';

export default {
  name: 'App',

  components: {
     Form,
  },

  data: () => ({
    //
  }),
};
</script>

<style>

 .v-main.plashka {
   /*background: url('./assets/images/homepage-background-01.jpg') center no-repeat;*/
   background-color: #fcce7e;
 }


 .line{
   margin: 10px 0;
   box-shadow: 0 0 17px 1px #fff;
   height: 2px;
   background: #ffffff;
   background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 17%, rgba(255,255,255,1) 52%, rgba(255,255,255,1) 83%, rgba(255,255,255,0) 100%); /* FF3.6-15 */
   background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 17%,rgba(255,255,255,1) 52%,rgba(255,255,255,1) 83%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
   background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 17%,rgba(255,255,255,1) 52%,rgba(255,255,255,1) 83%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
   filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */
 }

.w-text-fotter {
  font-size: 30px;
  font-style: italic;
  font-weight: bold;
}
.w-tel {
  font-size: 40px;
  font-weight: bold;
}

 .w-title-text {
   font-size: 100px;
   font-style: italic;
   font-weight: bold;
 }

 .w-absolute-image {
   position: absolute;
   width: 341px;
   top: -7px;
 }

  hr {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+52,ffffff+100&0+0,1+17,1+52,1+83,0+100 */
    background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 17%, rgba(255,255,255,1) 52%, rgba(255,255,255,1) 83%, rgba(255,255,255,0) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 17%,rgba(255,255,255,1) 52%,rgba(255,255,255,1) 83%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 17%,rgba(255,255,255,1) 52%,rgba(255,255,255,1) 83%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */

  }

  .w-margin-top {
    margin-top: 50px;
  }

 .w-button {
   box-shadow: 0 0 19px 2px #fff;
   text-transform: initial;
   letter-spacing: 0px;
   font-style: italic;
   padding: 35px 39px;
   border-radius: 12px;
 }

 @media (min-width: 767px) {
   .w-button-dialog {
     font-size: 40px!important;
     padding: 34px 42px!important;
   }
 }

 @media (max-width: 767px) {
   .w-backgraund-img1 {
     height: 500px;
   }
   .w-backgraund-img2 {
     width: 100%;
     background-size: contain;
   }
  .w-diznatysa-bilshe {
    width: 100%;
  }
   .w-title-text {
     font-size: 68px;
   }
   .w-absolute-image {
     display: none;
   }
   .w-button-dialog {
     font-size: 19pt!important;
     padding: 34px 42px!important;
   }

   .w-tel {
     font-size: 29px;
   }

   .w-right-bloc {
     display: block;
   }
   .w-text-fotter {
     font-size: 21px;
   }
 }




 .v-text-field--outlined > .v-input__control > .v-input__slot {
   background-color: #ffffff!important;
 }
 .v-dialog {
   position: relative;
 }

 .v-text-field--outlined fieldset {
   border: none;
 }


 table.customTable {
   width: 100%;
   background-color: transparent;
   border-collapse: collapse;
   border-width: 2px;
   border-color: #FFFFFF;
   border-style: solid;
   color: #56698f;
   font-style: italic;
   font-weight: bold;
 }



 table.customTable td, table.customTable th {
   border-width: 2px;
   border-color: #FFFFFF;
   border-style: solid;
   padding: 5px;
   text-align: center;
   box-shadow: 0 0 14px 0px #fff;
 }

 table.customTable thead {
   background-color: transparent;
 }

</style>